import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"margin":"30px 0px"} }
const _hoisted_2 = { class: "t6_title_h1" }
const _hoisted_3 = { class: "t6_search" }
const _hoisted_4 = { class: "tab_content" }
const _hoisted_5 = {
  key: 0,
  class: "tab_cont"
}
const _hoisted_6 = { class: "sq_list" }
const _hoisted_7 = { class: "li_tit" }
const _hoisted_8 = { class: "li_ms" }
const _hoisted_9 = { class: "li_btn" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "pagination" }

import {useRouter} from "vue-router";
import {reactive, ref, toRefs, watchEffect} from "vue";
import {getModelInfoList, queryListByTag} from "@/config/request";


export default /*@__PURE__*/_defineComponent({
  __name: 'itemTable',
  props: {
  tagName: String,
  keyWord:String,
  listName:String
},
  setup(__props) {


const router = useRouter()
const props = __props
const { tagName,keyWord,listName } = toRefs(props) as any
let data = reactive({
  fwqd: false,    //  false表示不是服务清单
})

const toPath = (item:any) => {
  router.push({
    path:'./one-thing/selection-situation',
    query: {
      modelCode:item.modelCode,
      modelName:item.modelName,
      parentid:item.parentid,
      theme:item.theme,
      hangyeType_dictText:item.hangyeType_dictText
    }
  })
}

const toWorkGuide = (item:any) => {
  router.push({
    path: '/do-things-online/work-guide',
    query: {
      serviceCode: item.serviceCode,
      serviceName: item.serviceName,
      tagName: item.tagName,
    },
  })
}

const toDeclaration = (item:any) => {
  let status = 0
  //  isKfSelf 自建事项 1是
  //  isWeburlEffect 外链生效 1不生效
  if(item.isKfSelf != '1' && item.isWeburlEffect != '1'){
    status = 1
    location.href = item.webUrl
  }
  let query = {
    serviceCode: item.serviceCode,
    serviceName: item.serviceName,
    tagName: item.tagName,
  } as any
  //  判断是否是秒批事项申报，因为有的事项既是普通事项又是秒批事项，通过申报位置判断后续申报逻辑
  if(tagName.value === '智能秒办'){
    query.ismp = '1'    //  1代表是秒批申报  其他值代表不是
  }
  if(status === 0){
    //  先跳转通知事项 再进入申报
    router.push({
      path: '/do-things-online/notic',
      query: query,
    })
  }
}


const toReservation = (item:any) => {
  let query = {
    serviceCode: item.serviceCode,
    serviceName: item.serviceName,
    tagName: item.tagName,
  } as any

  //  先跳转通知事项 再进入申报
  router.push({
    path: '/do-things-online/reservation',
    query: query,
  })
}
let keyWords = ref('')
if(keyWord.value){
  keyWords.value = keyWord.value
}
let dataList = ref([]) as any
const paginate = reactive({
  pageNo: 1,
  pageSize: 5,
  pageSizes: [5,10,20],
  total: 0,
})
const handleCurrentChange = (index:any) => {
  paginate.pageNo = index
  init()
}
const handleSizeChange = (index:any) => {
  paginate.pageSize = index
  init()
}
const openFile = (name:string) => {
  if(name) window.open(`/staticFile/${name}`)
}

const init = async() => {
    let param = {
      tagName: tagName.value,
      serviceName: keyWords.value,
      pageSize: paginate.pageSize,
      pageNo: paginate.pageNo,
    }
    const res = await queryListByTag(param) as any
    dataList.value = res.result?.records || []
    paginate.total = res.result?.total || 0

}
watchEffect(()=>{
  init()
})
init()

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"font-size":"24px","font-weight":"700","position":"relative","top":"-10px"} }, " 办事指南 ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "ipt_txt",
          placeholder: "请输入关键字查询",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(keyWords) ? (keyWords).value = $event : keyWords = $event))
        }, null, 512), [
          [_vModelText, _unref(keyWords)]
        ]),
        _createElementVNode("button", {
          class: "ss_btn",
          onClick: init
        }, "查 询")
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_unref(dataList).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.serviceName), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", null, "事项编码：" + _toDisplayString(item.serviceCode), 1),
                    _createElementVNode("span", null, "办理机构：" + _toDisplayString(item.deptName), 1),
                    _createElementVNode("span", null, "事项类型：" + _toDisplayString(item.serviceType_dictText), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("a", {
                      class: "btn1 green_border_btn",
                      onClick: ($event: any) => (toWorkGuide(item))
                    }, "办事指南", 8, _hoisted_10),
                    _createElementVNode("a", {
                      class: "btn1 blue_border_btn",
                      onClick: ($event: any) => (toDeclaration(item))
                    }, "在线申报", 8, _hoisted_11),
                    _createElementVNode("a", {
                      class: "btn1 green_border_btn",
                      onClick: ($event: any) => (toReservation(item))
                    }, "在线预约", 8, _hoisted_12)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_pagination, {
                background: "",
                onCurrentChange: handleCurrentChange,
                onSizeChange: handleSizeChange,
                layout: "sizes, prev, pager, next, ->, total",
                "page-size": paginate.pageSize,
                "page-sizes": paginate.pageSizes,
                total: paginate.total
              }, null, 8, ["page-size", "page-sizes", "total"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(dataList).length === 0)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            "image-size": "100",
            description: "暂无数据"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})